import classNames from 'classnames';
import React, { Component } from 'react';
import SVGInline from 'react-svg-inline';

import PlayScreenSpeedSelector from './play-screen-speed-selector';
import { EmbedContext } from '../../embed-video';
import { secondsToHumanReadableString } from '../../../../../shared/utilities/time';

import LoadingSpinner from 'components/ui-components/circular-loading-spinner';

import './styles.less';

const BIG_PLAY_BUTTON_SVG = `
<svg width="100%" height="100%" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    opacity="0.5"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.6231 0.464512L30.7389 14.1701C31.9466 15.0843 31.9466 16.9127 30.7389 17.8269L12.6231 31.5401C11.1286 32.6676 9 31.5934 9 29.7117V2.29294C9 0.403564 11.1286 -0.670635 12.6231 0.464512Z"
    fill="var(--brandThemedBigPlayButtonIconColor, black)"
  />
</svg>
`;

class PlayScreen extends Component {
  state = { isLoading: false };
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  render() {
    const { isLoading } = this.state;
    const { fullScreen, theaterMode } = this.props;

    return (
      <EmbedContext.Consumer>
        {({ hideSpeedSelector }) => (
          <div
            className={classNames(
              'video-player-play-screen',
              isLoading && 'is-loading',
              (theaterMode || fullScreen) && 'large-format'
            )}
            onClick={this.onClick}
          >
            <div className="button-container">
              <div className="big-play-button">
                {!isLoading && (
                  <SVGInline
                    className="big-play-button-icon"
                    svg={String(BIG_PLAY_BUTTON_SVG)}
                  />
                )}
                {isLoading && (
                  <LoadingSpinner color="var(--brandThemedBigPlayButtonIconColor, black)" />
                )}
              </div>
              <div className="relative-el">
                {!hideSpeedSelector && <PlayScreenSpeedSelector />}
              </div>
            </div>
            {this.props.duration > 0 && (
              <p className="play-screen-duration">
                {secondsToHumanReadableString(this.props.duration)}
              </p>
            )}
          </div>
        )}
      </EmbedContext.Consumer>
    );
  }

  onClick() {
    if (this.props.onPlay) {
      this.setState({ isLoading: true });
      this.props.onPlay();
    }
  }
}

export default PlayScreen;
